// Contrast Color Foundation
// This Color Palette consists of dark MainMenu
// and light content area

export default {
   globalNavLogoFieldName: 'logoDefaultNegative',
   tmpBackgroundColor: '#fff',
   tmpBodyTextColor: '#666',
   // Main Menu
   tmpMainMenuBorderColor: '#111',
   tmpMainMenuButtonTextColor: '#777',
   tmpMainMenuButtonActiveTextColor: '#fff',
   tmpMainMenuButtonActiveBackgroundColor: '#111',
   tmpMainMenuLineColor: 'rgba(255,255,255,0.07)',
   tmpMainMenuTextColor: 'rgba(255,255,255,0.4)',
   // Content
   tmpContentBackgroundColor: '#fff',
   tmpContentLineColor: '#eee'
}
